/**
 * Logger utility for consistent logging across the application.
 * Provides different log levels and can be configured to disable logs in production.
 */

// Environment check for production mode
const isProduction = import.meta.env.PROD;

// Logger configuration
const loggerConfig = {
  // Set to false to disable all logs in production
  enableLogsInProduction: false,
  // Log level (higher number = more verbose)
  // 0 = none, 1 = error, 2 = warn, 3 = info, 4 = debug
  logLevel: isProduction ? 1 : 4,
};

/**
 * Logger utility for application-wide logging
 */
const logger = {
  /**
   * Log error messages - always logged unless completely disabled
   */
  error: (message: string, ...args: any[]) => {
    if (loggerConfig.logLevel >= 1 && (!isProduction || loggerConfig.enableLogsInProduction)) {
      console.error(message, ...args);
    }
  },
  
  /**
   * Log warning messages - logged at level 2+
   */
  warn: (message: string, ...args: any[]) => {
    if (loggerConfig.logLevel >= 2 && (!isProduction || loggerConfig.enableLogsInProduction)) {
      console.warn(message, ...args);
    }
  },
  
  /**
   * Log info messages - logged at level 3+
   */
  info: (message: string, ...args: any[]) => {
    if (loggerConfig.logLevel >= 3 && (!isProduction || loggerConfig.enableLogsInProduction)) {
      console.info(message, ...args);
    }
  },
  
  /**
   * Log debug messages - only logged at level 4 (not in production)
   */
  debug: (message: string, ...args: any[]) => {
    if (loggerConfig.logLevel >= 4 && (!isProduction || loggerConfig.enableLogsInProduction)) {
      console.debug(message, ...args);
    }
  }
};

export default logger; 